import config from "../constants/config"

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding)
    .replace(/-/g, "+")
    .replace(/_/g, "/");
  const rawData = atob(base64);
  return Uint8Array.from([...rawData].map((c) => c.charCodeAt(0)));
}

export async function registerWebPush(email) {
  if (!("serviceWorker" in navigator)) {
    console.warn("[WebPush] Service workers non supportés");
    return;
  }

  try {
    const registration = await navigator.serviceWorker.register("/service-worker.js");
    console.log("[WebPush] Service worker enregistré");
    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
      console.warn("[WebPush] Permission refusée");
      return;
    }
    const subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(config.VAPID_PUBLIC_KEY),
    });
    await fetch(`/save-subscription?email=${email}`, {
  method: "POST",
  body: JSON.stringify(subscription),
  headers: { "Content-Type": "application/json" },
});


    console.log("[WebPush] Subscription envoyée au serveur");
  } catch (err) {
    console.error("[WebPush] Erreur d’enregistrement :", err);
  }
}
